import { fetchListingsAndFilters } from '../fetchers';
import { removeEmptyMakeFilter, getInventorySortOption } from '../utilities';
import { set } from '../utilities/common';

function isShowInventory(data) {
    return data.listings?.length > 0;
}

export default function getListingsAndFilters(isDesktop = true) {
    return async (ctx) => {
        let data = {};
        const [, { channel }] = ctx.useFeature('brand');
        const query = {
            ...ctx.query,
            stats: ['year', 'derivedprice'],
            channel: channel || ctx.data.brand.toUpperCase(),
        };
        const fetchOptions = {};
        const defaultSortOption = getInventorySortOption(ctx.data.brand);
        const sortBy = !query.sortBy && { sortBy: defaultSortOption };

        delete query.location;
        delete query.dma;

        if (isDesktop) {
            if (ctx.req) {
                // add cookie to headers so we don't lose it on the server
                fetchOptions.headers = {
                    cookie: ctx.req.headers.cookie,
                };
            }

            data = await fetchListingsAndFilters({
                ...fetchOptions,
                // TODO: bonnet-atc - should this be pared down to only the query params we care about?
                query: {
                    marketExtension: 'include',
                    ...query,
                    ...sortBy,
                },
            });
        } else {
            ctx.data.resultIsLoading = true;
        }

        if (query.searchRadius < 50 || query.minPrice || query.maxPrice
            || query.startYear || query.endYear || query.mileage
            || query.fuelTypeGroup || query.doorCode || query.engineCode
            || query.featureCode || query.vehicleStyleCode || query.listingType
            || query.listingFeature || query.dealType || query.transmissionCode
            || query.driveGroup || query.extColorSimple || query.makeCode
            || query.mpgRange || query.intColorSimple
        ) {
            const noFilterData = await fetchListingsAndFilters({
                ...fetchOptions,
                query: {
                    marketExtension: 'include',
                    dealerId: query.dealerId,
                    channel: query.channel,
                },
            });
            const supportMakes = removeEmptyMakeFilter(noFilterData?.filters?.makeCode?.options);
            data.supportMakes = supportMakes;
            data.showInventory = isShowInventory(noFilterData);
        }

        // if showInventory equals false then clear the inventory filters
        if (!data.showInventory) {
            set(data, 'filters', {});
        }

        // update the context data object with the response
        Object.assign(ctx.data, data);
    };
}
